export { default as wrapRootElement } from 'src/ducks/storeProvider'
